import React from 'react'
import { useCourse } from '../CourseContext'

export const useFunctions = () => {

    const { currentCourse, setCourse } = useCourse()

    const updateStatusModule = (course, current_modul, value) => {
        const updatedCourse = { ...course }

        if (current_modul) {

            const moduleIndex = updatedCourse.moduls.findIndex(
                (module) => module._id === current_modul._id
            )

            if (moduleIndex !== -1) {

                const updatedModule = { ...updatedCourse.moduls[moduleIndex] }

                updatedModule.status = value

                updatedCourse.moduls[moduleIndex] = updatedModule


                setCourse(updatedCourse)
            } else {
                console.log('Módulo no encontrado')
            }
        } else {
            console.log('Módulo no encontrado: ', current_modul)
        }

        return updatedCourse

    }

    const find_current_module = (course, current_modul) => {
        const moduls = course?.moduls || []
        return moduls.find((module) => module._id === current_modul._id)
    }

    const find_next_module = (course, current_modul) => {
        const moduls = course?.moduls || [];
        const currentIndex = moduls.findIndex((module) => module._id === current_modul._id);

        if (currentIndex !== -1 && currentIndex < moduls.length - 1) {
            return moduls[currentIndex + 1];
        }

        return null;
    }

    const updateStatusCourse = (currentCourse, value) => {

        const updatedCourse = { ...currentCourse };

        if (currentCourse) {

            updatedCourse.status = value;

            //   console.log('Curso actualizado:', JSON.stringify(updatedCourse, null, 2));

            setCourse(updatedCourse);
            
        } else {
            console.error('Curso no encontrado');
        }

        return updatedCourse
    };

    return {
        updateStatusModule,
        find_current_module,
        find_next_module,
        updateStatusCourse
    }
}
